import utils from "../../../utils/utils";

// Bekleyen istek sayacı sıfıra düşünce katmanı hemen kapatmıyoruz; arka arkaya gelen
// istekler (ör. lazy route chunk'ı inerken) arasında katmanın açılıp kapanmasını önler.
const HIDE_DELAY_MS = 250;
let hideTimer = null;

export default {
    throwError(context, payload) {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

        let warningPanelText = "";
        
        if (payload && payload.cause) {
            warningPanelText = payload.message;
        } else if (payload && !payload.cause && payload.customError) {
            warningPanelText = payload.warningPanelText;
        } else if (payload && !payload.cause && !payload.customError) {
            const uuid = "XPS-" + self.crypto.randomUUID().substring(0, 11);

            warningPanelText = `Beklenmedik bir hata oluştu. Lütfen daha sonra tekrar deneyiniz. (${uuid})`;

            context.dispatch("logClientSideError", { traceId: uuid, message: payload.message });
        } else {
            warningPanelText = "Beklenmedik bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.";
        }

        context.commit("setError", { hasError: true, warningPanelText: warningPanelText });
    },
    throwFormError(context, payload) {
        let warningPanelText = "";
        let isExplainableError = false;

        if (payload && payload.cause) {
            warningPanelText = payload.message;
            isExplainableError = true; 
        } else if (payload && !payload.cause && payload.customError) {
            warningPanelText = payload.warningPanelText;
        } else if (payload && !payload.cause && !payload.customError) {
            const uuid = "XPS-" + self.crypto.randomUUID().substring(0, 11);

            warningPanelText = `Beklenmedik bir hata oluştu. Lütfen daha sonra tekrar deneyiniz. (${uuid})`;

            context.dispatch("logClientSideError", { traceId: uuid, message: payload.message });
        } else {
            warningPanelText = "Beklenmedik bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.";
        }

        context.commit("setFormError", { warningPanelText: warningPanelText, isExplainableError: isExplainableError });
    },
    clearError(context) {
        context.commit("setError", { hasError: false, warningPanelText: "" });
    },
    clearFormError(context) {
        context.commit("clearFormError");
    },
    pageIsLoading(context, payload) {
        if (payload) {
            clearTimeout(hideTimer);
            hideTimer = null;
            context.commit("incrementPendingRequests");
            context.commit("setPageStatus", true);
            return;
        }

        context.commit("decrementPendingRequests");

        if (context.state.pendingRequestCount > 0) return;

        clearTimeout(hideTimer);
        hideTimer = setTimeout(() => {
            hideTimer = null;
            if (context.state.pendingRequestCount === 0) context.commit("setPageStatus", false);
        }, HIDE_DELAY_MS);
    },
    setExplainInProgress(context, payload) {
        context.commit("setExplainInProgress", payload);
    },
    async logClientSideError(_, payload) {
        utils.utility.fetch("api/workspace/postclientsideerror", "POST", null, payload, true);
    },
    dialogOpened(context, payload) {
        context.commit("setDialogOpenedStatus", payload);
    }
}